import { css } from 'styled-components';

import { CheckboxLabel } from './CheckboxLabel';
import { CheckboxBackground } from './CheckboxBackground';

export const CheckboxInputStyles = css`
  width: 1px;
  height: 1px;
  position: absolute;
  top: 0;
  left: -999px;
  clip: rect(1px, 1px, 1px, 1px);
  overflow: hidden;
  white-space: nowrap;

  /* stylelint-disable selector-type-no-unknown */
  &:focus ~ ${CheckboxBackground} {
    outline: ${({ theme }) => theme.outline};
  }

  &:checked + ${CheckboxLabel}::before {
    border: 2px solid ${({ theme: { input } }) => input.colorFocus};
    background-color: ${({ theme: { checkbox } }) => checkbox.colorBackgroundChecked};
  }

  &:checked + ${CheckboxLabel}::after {
    position: absolute;
    content: '';
    left: 0.4375em;
    top: 0.4375em;
    z-index: 9;
    width: 0.875em;
    height: 0.875em;
    background-size: auto 0.75em;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: ${({ theme: { input } }) => input.borderRadius};
  }
  /* stylelint-enable */
`;
